/** 輕量提示（member-card 無 antd 時替代 alert） */
export function toastMessage(text, type = 'info') {
  if (typeof document === 'undefined') return;
  const el = document.createElement('div');
  const bg = type === 'error' ? '#cf1322' : type === 'success' ? '#7b4f2f' : '#3b2c24';
  el.textContent = String(text || '');
  Object.assign(el.style, {
    position: 'fixed',
    top: '16px',
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: '10000',
    background: bg,
    color: '#fff',
    padding: '10px 16px',
    borderRadius: '8px',
    fontSize: '14px',
    boxShadow: '0 4px 16px rgba(0,0,0,.2)',
    maxWidth: '90vw',
  });
  document.body.appendChild(el);
  window.setTimeout(() => el.remove(), 2800);
}
